<template>
  <div
    class="d-flex flex-column"
    :class="{ 'invoice-index-container': version >= 1 }"
  >
    <listing-v2 />
  </div>
</template>
<script>
import ListingV2 from './indexV2'
import { freshdeskMixin } from '@/mixins/Freshdesk'

export default {
  data() {
    return {
      version: parseInt(this.$store.state.account.portalVersion)
    }
  },
  mounted() {
    this.$mpTrack('Invoices page mounted')
    if (this.$store.state.account.country === 'India') {
      this.showAndPrefillFreshdesk({ cf_category_i: 'Invoice related' })
    }
  },
  components: {
    ListingV2
  },
  mixins: [freshdeskMixin]
}
</script>
<style lang="scss" scoped>
.invoice-index-container {
  height: 100%;
}
</style>
